/**
 * Criteria is used to wrap Criterion UI component, with controls to redux and render.
 */
import { toggleRightSider } from 'components/page/RightSider/flow/action';
import { Criterion } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  removeCriterionByDisplayNum,
  setCriterionByColumn,
  tryFetchOptionsIfNeeded,
  setSiderSelectedValueList,
} from '../flow/actions';
import { getConditionsByFieldType, shouldConditionDisabled } from '../utils/compUtils';
import CriteriaHeader from './CriteriaHeader';
import Sider from './Sider';
import ValueColumn from './ValueColumn';
import { setWidth } from 'components/page/EnhancedSider/flow/actions';

const defaultProps = {
  setCriterionByColumn: null,
};
const propTypes = {
  criteria: PropTypes.arrayOf(PropTypes.shape({
    displayNum: PropTypes.number.isRequired,
    fieldId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    conditionId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    value: PropTypes.string,
    field: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      lookupKey: PropTypes.string.isRequired,
    }),
    options: PropTypes.array,
    subtype: PropTypes.string,
    rangeValue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  })).isRequired,
  fields: PropTypes.array.isRequired,
  setCriterionByColumn: PropTypes.func,
};

class Criteria extends Component {
  // TODO: clean up
  handleFilterFieldChange = (displayNum, newValue) => this.props.setCriterionByColumn('field', displayNum, newValue)
  handleFilterConditionChange = (displayNum, newValue) => this.props.setCriterionByColumn('condition', displayNum, newValue)
  handleFilterValueChange = (displayNum, newValue, newSubtype) => this.props.setCriterionByColumn('value', displayNum, newValue, newSubtype)
  handleFilterDeleteClick = displayNum => this.props.removeCriterionByDisplayNum(displayNum)
  handleSearchIconClick = (criterion) => {
    this.props.setWidth('right', 300);
    this.props.tryFetchOptionsIfNeeded(criterion);
    this.props.toggleRightSider(false);
  }

  render() {
    const {
      criteria,
      conditions,
      fields,
      needSearchBar
    } = this.props;

    return (
      <Fragment>
        <CriteriaHeader />
        {criteria.map(c => (
          <Criterion
            key={c.displayNum}
            displayNum={c.displayNum}
            fieldId={c.fieldId}
            conditionId={c.conditionId}
            shouldConditionDisabled={shouldConditionDisabled(c.subtype)}
            availableFields={fields}
            restriction={c.restriction}
            availableConditions={getConditionsByFieldType(
              c.field ? c.field.type : null,
              conditions,
            )}
            needSearchBar={needSearchBar}
            onFilterFieldChange={newValue => this.handleFilterFieldChange(c.displayNum, newValue)}
            onFilterConditionChange={newValue => this.handleFilterConditionChange(c.displayNum, newValue)}
            onFilterDeleteClick={() => this.handleFilterDeleteClick(c.displayNum)}
          >
            <ValueColumn
              onSearchIconClick={() => {
                this.handleSearchIconClick(c);
                this.props.setSiderSelectedValueList(c.value)
              }}
              onValueChange={(newSubtype, newValue) => this.handleFilterValueChange(c.displayNum, newValue, newSubtype)}
              // NOTES:
              // This prop is used by the ValueColumn component, because it contains complex business logic,
              // so we pass data to it, and let it handle more complex behavior by itself.
              restriction={c.restriction}
              record={c}
            />
          </Criterion>
        ))}
        <Sider />
      </Fragment>
    );
  }
}

Criteria.defaultProps = defaultProps;
Criteria.propTypes = propTypes;
const mapStateToProps = ({ global, FilterCriteria__REFACTORED }) => ({
  language: global.language,
  conditions: global.settings.conditions,
  criteria: FilterCriteria__REFACTORED.criteria.criteria,
  fields: FilterCriteria__REFACTORED.criteria.fields,
});
const mapDispatchToProps = {
  setCriterionByColumn,
  removeCriterionByDisplayNum,
  toggleRightSider,
  tryFetchOptionsIfNeeded,
  setWidth,
  setSiderSelectedValueList,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Criteria);



// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria__REFACTORED/components/Criteria.jsx